/** @jsx jsx */
import { jsx } from 'theme-ui'
import { cf2imgix } from '../../utils/cf2imgix'
import {
  AIRALO,
  COMMUNITY_FIBRE,
  DISNEY_PLUS,
  EE,
  GIFF_GAFF,
  ID_MOBILE,
  LEBARA,
  MUSIC_MAGPIE,
  O2,
  PIXEL,
  PLUSNET,
  SKY,
  SMARTY,
  TESCO_MOBILE
} from '../brands/brandImages'
import { JUDGES_CHOICE, OPENSIGNAL_CHOICE, PUBLIC_CHOICE } from './broadbandTv'

export const AwardLabel = ({ icon, title, bgColor = '#50F094' }) => (
  <div
    sx={{
      background: bgColor,
      borderRadius: '100px',
      display: 'flex',
      alignItems: 'center',
      color: '#141414',
      py: '2px',
      px: '8px',
      maxWidth: 150
    }}
  >
    {icon}
    <p sx={{ m: 0, ml: '6px', fontSize: 14 }}>{title}</p>
  </div>
)

export const DatabaseIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 20 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 10.5C6 11.3284 5.32843 12 4.5 12C3.67157 12 3 11.3284 3 10.5C3 9.67157 3.67157 9 4.5 9C5.32843 9 6 9.67157 6 10.5Z"
      fill="#141414"
    />
    <path
      d="M6 19.5C6 20.3284 5.32843 21 4.5 21C3.67157 21 3 20.3284 3 19.5C3 18.6716 3.67157 18 4.5 18C5.32843 18 6 18.6716 6 19.5Z"
      fill="#141414"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 0C15.5228 0 20 1.79086 20 4V22C20 22.8519 19.4811 23.5044 18.9117 23.9531C18.331 24.4108 17.5528 24.7791 16.6802 25.07C14.9246 25.6552 12.5629 26 10 26C7.43715 26 5.07541 25.6552 3.31981 25.07C2.44724 24.7791 1.66896 24.4108 1.08829 23.9531C0.518893 23.5044 0 22.8519 0 22V4C0 1.79086 4.47715 0 10 0ZM17.8399 3.89613C17.8826 3.93647 17.9155 3.9711 17.9407 4C17.9155 4.0289 17.8826 4.06353 17.8399 4.10387C17.5788 4.3508 17.0937 4.66533 16.3283 4.97147C14.8086 5.57933 12.5721 6 10 6C7.42788 6 5.19136 5.57933 3.67171 4.97147C2.90634 4.66533 2.42118 4.3508 2.16007 4.10387C2.11741 4.06353 2.08451 4.0289 2.05929 4C2.08451 3.9711 2.11741 3.93647 2.16007 3.89613C2.42118 3.6492 2.90634 3.33467 3.67171 3.02853C5.19136 2.42067 7.42788 2 10 2C12.5721 2 14.8086 2.42067 16.3283 3.02853C17.0937 3.33467 17.5788 3.6492 17.8399 3.89613ZM18 6.40039V13.0002C18 13.0002 17.9999 13.0057 17.9969 13.0153C17.9935 13.0264 17.9852 13.0485 17.9649 13.0814C17.9225 13.1506 17.8359 13.2545 17.6738 13.3823C17.3436 13.6425 16.8038 13.9206 16.0477 14.1726C14.546 14.6732 12.4077 15 10 15C7.59229 15 5.45402 14.6732 3.95227 14.1726C3.19616 13.9206 2.65642 13.6425 2.32624 13.3823C2.16408 13.2545 2.07752 13.1506 2.03507 13.0814C2.01483 13.0485 2.00645 13.0264 2.00305 13.0153C1.99998 13.0052 2 13 2 13V6.40039C3.82446 7.37173 6.7288 8 10 8C13.2712 8 16.1755 7.37173 18 6.40039ZM18 22V15.5266C17.5988 15.7318 17.1533 15.9123 16.6802 16.07C14.9246 16.6552 12.5629 17 10 17C7.43715 17 5.07541 16.6552 3.31981 16.07C2.84666 15.9123 2.40123 15.7318 2 15.5266L2 22.0001C2 22.0001 1.99998 22.0052 2.00305 22.0153C2.00645 22.0264 2.01483 22.0485 2.03507 22.0814C2.07752 22.1506 2.16408 22.2545 2.32624 22.3823C2.65642 22.6425 3.19616 22.9206 3.95227 23.1726C5.45402 23.6732 7.59229 24 10 24C12.4077 24 14.546 23.6732 16.0477 23.1726C16.8038 22.9206 17.3436 22.6425 17.6738 22.3823C17.8359 22.2545 17.9225 22.1506 17.9649 22.0814C17.9852 22.0485 17.9935 22.0264 17.9969 22.0153C17.9979 22.012 17.9986 22.0094 17.9991 22.0072C17.9995 22.005 17.9999 22.0021 17.9999 22.0021L18 22Z"
      fill="#141414"
    />
  </svg>
)

export const PeopleIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 26 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 6.5C15 10.0899 12.0899 13 8.5 13C4.91015 13 2 10.0899 2 6.5C2 2.91015 4.91015 0 8.5 0C12.0899 0 15 2.91015 15 6.5ZM13 6.5C13 8.98528 10.9853 11 8.5 11C6.01472 11 4 8.98528 4 6.5C4 4.01472 6.01472 2 8.5 2C10.9853 2 13 4.01472 13 6.5Z"
      fill="#141414"
    />
    <path
      d="M17.5 13C16.863 13 16.2473 12.9084 15.6656 12.7375C16.138 12.1953 16.5498 11.599 16.8906 10.9591C17.0899 10.9861 17.2933 11 17.5 11C19.9853 11 22 8.98528 22 6.5C22 4.01472 19.9853 2 17.5 2C17.2933 2 17.0899 2.01393 16.8906 2.04091C16.5498 1.40099 16.138 0.804663 15.6656 0.262453C16.2473 0.0916389 16.863 0 17.5 0C21.0899 0 24 2.91015 24 6.5C24 10.0899 21.0899 13 17.5 13Z"
      fill="#141414"
    />
    <path
      d="M0 20C0 17.2386 2.23858 15 5 15H12C14.7614 15 17 17.2386 17 20V25H15V20C15 18.3431 13.6569 17 12 17H5C3.34315 17 2 18.3431 2 20V25H0V20Z"
      fill="#141414"
    />
    <path
      d="M19 17H21C22.6569 17 24 18.3431 24 20V25H26V20C26 17.2386 23.7614 15 21 15H19V17Z"
      fill="#141414"
    />
  </svg>
)

export const CupIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 0H21V4H26V8C26 11.2028 23.4906 13.8194 20.3306 13.991C19.209 16.3608 16.7959 18 14 18V20H15C17.6124 20 19.8349 21.6696 20.6586 24C20.8797 24.6256 21 25.2987 21 26H5C5 25.2987 5.12031 24.6256 5.34141 24C6.16508 21.6696 8.38756 20 11 20H12V18C9.20408 18 6.79101 16.3608 5.66938 13.991C2.50944 13.8194 0 11.2028 0 8V4H5V0ZM12 16C9.23858 16 7 13.7614 7 11V2H19V11C19 13.7614 16.7614 16 14 16H12ZM2 6H5V11.874C3.27477 11.4299 2 9.86384 2 8V6ZM21 6V11.874C22.7252 11.4299 24 9.86384 24 8V6H21ZM11 22H15C16.4806 22 17.7733 22.8044 18.4649 24H7.53513C8.22675 22.8044 9.51944 22 11 22Z"
      fill="#141414"
    />
  </svg>
)

const LOGO_STYLES = {
  modal: { height: '92px' },
  moreWinnersCard: { height: ['48px', '64px'], maxWidth: '100%' },
  winnersCard: { height: '100%', width: 'auto', padding: 0 }
}

const BROADBAND_PROVIDER_DEFAULTS = {
  plusnet: {
    providerName: 'Plusnet',
    awardLabel: <PUBLIC_CHOICE />,
    winnersLogoModal: (
      <img alt="logo" sx={LOGO_STYLES.modal} src={cf2imgix(PLUSNET)} />
    ),
    winnersLogoCard: (
      <img alt="logo" sx={LOGO_STYLES.winnersCard} src={cf2imgix(PLUSNET)} />
    ),
    moreWinnersLogoCard: (
      <img
        alt="logo"
        sx={LOGO_STYLES.moreWinnersCard}
        src={cf2imgix(PLUSNET)}
      />
    ),
    providerLink: 'https://www.uswitch.com/broadband/providers/plusnet/',
    ctaTitle: 'View Plusnet deals'
  },
  communityFibre: {
    providerName: 'Community Fibre',
    awardLabel: <PUBLIC_CHOICE />,
    winnersLogoModal: (
      <img
        alt="logo"
        sx={{ height: 'auto', width: 'min(325px, 100%)', padding: 0 }}
        src={cf2imgix(COMMUNITY_FIBRE)}
      />
    ),
    winnersLogoCard: (
      <img
        alt="logo"
        sx={{ width: '100%', height: 'auto' }}
        src={cf2imgix(COMMUNITY_FIBRE)}
      />
    ),

    awardTitle: 'Alternative Broadband Provider of the Year',
    providerLink:
      'https://www.uswitch.com/broadband/providers/community_fibre/',
    ctaTitle: 'View Community Fibre deals'
  },
  sky: {
    providerName: 'Sky',
    awardLabel: <PUBLIC_CHOICE />,
    winnersLogoModal: (
      <img alt="logo" sx={LOGO_STYLES.modal} src={cf2imgix(SKY)} />
    ),
    moreWinnersLogoCard: (
      <img alt="logo" sx={LOGO_STYLES.moreWinnersCard} src={cf2imgix(SKY)} />
    ),
    winnersLogoCard: (
      <img alt="logo" sx={LOGO_STYLES.winnersCard} src={cf2imgix(SKY)} />
    ),

    ctaTitle: 'View Sky deals',
    providerLink: 'https://www.uswitch.com/broadband/providers/sky/'
  },
  ee: {
    providerName: 'EE',
    winnersLogoModal: (
      <img alt="logo" sx={LOGO_STYLES.modal} src={cf2imgix(EE)} />
    ),
    moreWinnersLogoCard: (
      <img alt="logo" sx={LOGO_STYLES.moreWinnersCard} src={cf2imgix(EE)} />
    ),

    awardLabel: <PUBLIC_CHOICE />
  },
  disneyPlus: {
    providerName: 'Disney+',
    winnersLogoModal: (
      <img alt="logo" sx={LOGO_STYLES.modal} src={cf2imgix(DISNEY_PLUS)} />
    ),
    moreWinnersLogoCard: (
      <img
        alt="logo"
        sx={LOGO_STYLES.moreWinnersCard}
        src={cf2imgix(DISNEY_PLUS)}
      />
    ),

    awardLabel: <PUBLIC_CHOICE />
  }
}

const MOBILES_PROVIDER_DEFAULTS = {
  lebara: {
    providerName: 'Lebara',
    moreWinnersLogoCard: (
      <img alt="logo" sx={LOGO_STYLES.moreWinnersCard} src={cf2imgix(LEBARA)} />
    ),
    winnersLogoModal: (
      <img alt="logo" sx={LOGO_STYLES.modal} src={cf2imgix(LEBARA)} />
    ),

    awardLabel: <PUBLIC_CHOICE />,
    providerLink:
      'https://www.uswitch.com/mobiles/compare/sim_only_deals/lebara_mobile/',
    ctaTitle: 'View Lebara deals'
  },
  tesco: {
    providerName: 'Tesco Mobile',
    winnersLogoCard: (
      <img
        alt="logo"
        sx={{ width: '80%', height: 'auto' }}
        src={cf2imgix(TESCO_MOBILE)}
      />
    ),
    moreWinnersLogoCard: (
      <img
        alt="logo"
        sx={{ height: 'auto', width: 'min(175px, 100%)' }}
        src={cf2imgix(TESCO_MOBILE)}
      />
    ),
    winnersLogoModal: (
      <img
        alt="logo"
        sx={{ height: 'auto', width: 'min(240px, 100%)' }}
        src={cf2imgix(TESCO_MOBILE)}
      />
    ),
    providerLink:
      'https://www.uswitch.com/mobiles/compare/phone-contracts/?networks[]=tesco',
    ctaTitle: 'View Tesco Mobile deals',

    awardLabel: <PUBLIC_CHOICE />
  },

  pixel8: {
    providerName: 'Google Pixel 8 Pro',
    winnersLogoCard: (
      <img
        alt="logo"
        sx={{ width: '80%', height: 'auto' }}
        src={cf2imgix(PIXEL)}
      />
    ),
    winnersLogoModal: (
      <img
        alt="logo"
        sx={{ height: 'auto', width: 'min(225px, 100%)' }}
        src={cf2imgix(PIXEL)}
      />
    ),
    providerLink: 'https://www.uswitch.com/mobiles/google-pixel-8-pro-deals/',

    awardLabel: <JUDGES_CHOICE />
  },

  o2: {
    providerName: 'O2',
    moreWinnersLogoCard: (
      <img alt="logo" sx={LOGO_STYLES.moreWinnersCard} src={cf2imgix(O2)} />
    ),
    winnersLogoModal: (
      <img alt="logo" sx={LOGO_STYLES.modal} src={cf2imgix(O2)} />
    ),

    awardLabel: <PUBLIC_CHOICE />,
    providerLink: 'https://www.uswitch.com/mobiles/compare/sim_only_deals/o2/',
    ctaTitle: 'View O2 deals'
  },
  idMobile: {
    providerName: 'iD Mobile',
    winnersLogoModal: (
      <img
        alt="logo"
        sx={{ height: 'auto', width: 'min(320px, 100%)' }}
        src={cf2imgix(ID_MOBILE)}
      />
    ),
    moreWinnersLogoCard: (
      <img
        alt="logo"
        sx={{ height: 'auto', width: 'min(225px, 100%)' }}
        src={cf2imgix(ID_MOBILE)}
      />
    ),
    awardLabel: <PUBLIC_CHOICE />,

    providerLink:
      'https://www.uswitch.com/mobiles/compare/phone-contracts/?networks[]=id-mobile',
    ctaTitle: 'View iD Mobile deals',
    noFollow: true
  },
  skyMobile: {
    providerName: 'Sky Mobile',
    winnersLogoModal: (
      <img alt="logo" sx={LOGO_STYLES.modal} src={cf2imgix(SKY)} />
    ), // TODO -- mobile logo
    moreWinnersLogoCard: (
      <img alt="logo" sx={LOGO_STYLES.moreWinnersCard} src={cf2imgix(SKY)} />
    ),
    awardLabel: <PUBLIC_CHOICE />,

    providerLink:
      'https://www.uswitch.com/mobiles/compare/phone-contracts/?networks[]=sky-mobile',
    ctaTitle: 'View Sky Mobile deals'
  },
  ee: {
    providerName: 'EE',
    winnersLogoModal: (
      <img alt="logo" sx={LOGO_STYLES.modal} src={cf2imgix(EE)} />
    ),
    moreWinnersLogoCard: (
      <img alt="logo" sx={LOGO_STYLES.moreWinnersCard} src={cf2imgix(EE)} />
    ),
    awardLabel: <OPENSIGNAL_CHOICE />,
    providerLink:
      'https://www.uswitch.com/mobiles/compare/sim_only_deals/ee_network/',
    ctaTitle: "View deals on EE's network",
    ctaTitleMobile: 'EE network deals'
  },
  giffgaff: {
    providerName: 'giffgaff',
    winnersLogoModal: (
      <img alt="logo" sx={LOGO_STYLES.modal} src={cf2imgix(GIFF_GAFF)} />
    ),
    moreWinnersLogoCard: (
      <img
        alt="logo"
        sx={{ height: 'auto', width: 'min(100%, 235px)' }}
        src={cf2imgix(GIFF_GAFF)}
      />
    ),
    awardLabel: <PUBLIC_CHOICE />,
    providerLink:
      'https://www.uswitch.com/mobiles/compare/sim_only_deals/pay_as_you_go_sim_deals/?networks[]=giffgaff',
    ctaTitle: 'View giffgaff deals'
  },
  smarty: {
    providerName: 'SMARTY',
    winnersLogoModal: (
      <img
        alt="logo"
        sx={{ height: 'auto', width: 'min(270px, 100%)' }}
        src={cf2imgix(SMARTY)}
      />
    ),
    moreWinnersLogoCard: (
      <img alt="logo" sx={LOGO_STYLES.moreWinnersCard} src={cf2imgix(SMARTY)} />
    ),
    awardLabel: <PUBLIC_CHOICE />,
    providerLink:
      'https://www.uswitch.com/mobiles/compare/sim_only_deals/smarty/',
    ctaTitle: 'View SMARTY deals'
  },
  airalo: {
    providerName: 'Airalo',
    winnersLogoModal: (
      <img alt="logo" sx={LOGO_STYLES.modal} src={cf2imgix(AIRALO)} />
    ),
    moreWinnersLogoCard: (
      <img alt="logo" sx={LOGO_STYLES.moreWinnersCard} src={cf2imgix(AIRALO)} />
    ),
    awardLabel: <JUDGES_CHOICE />
  }
}

export const WINNERS_CONFIG = {
  bestProviderBB: {
    ...BROADBAND_PROVIDER_DEFAULTS.plusnet,
    awardDescription:
      "Plusnet proved a deserving winner for the second year in a row due to its value, customer service, reliability and positive sentiment among those surveyed. Fast and affordable broadband with friendly support? That'll do.",
    awardTitle: 'Broadband Provider of the Year'
  },
  bestAlternativeBB: {
    ...BROADBAND_PROVIDER_DEFAULTS.communityFibre,
    awardTitle: 'Alternative Broadband Provider of the Year',
    awardDescription:
      'Recognised for its ultrafast speeds, great customer experience and competitive prices, Community Fibre leads as the premier alternative broadband provider.'
  },

  mostPopularBB: {
    ...BROADBAND_PROVIDER_DEFAULTS.sky,
    awardTitle: 'Most Popular Broadband Provider',
    awardDescription:
      'Sky reigns as the Uswitch Telecoms Awards most popular broadband provider, ranking highly for both customer satisfaction and strong Uswitch sales across the last year.'
  },
  bestProviderCS: {
    ...BROADBAND_PROVIDER_DEFAULTS.plusnet,
    awardTitle: 'Best Provider for Customer Service',
    awardDescription:
      'Plusnet triumphs again for its revered customer support, with our survey results demonstrating its commitment to providing fast, effective support for all of its customers.'
  },
  mostReliableBB: {
    ...BROADBAND_PROVIDER_DEFAULTS.plusnet,
    awardTitle: 'Most Reliable Broadband Provider',
    awardDescription:
      "Plusnet's strong and consistent service saw it recognised as 2024's most reliable broadband provider, according to our survey of over 20,000 UK broadband customers."
  },
  bestValueForMoneyBB: {
    ...BROADBAND_PROVIDER_DEFAULTS.plusnet,
    awardTitle: 'Best Value for Money Broadband Provider',
    awardDescription:
      "Offering budget-friendly plans without compromising on quality, we've also awarded Plusnet as 2024's best choice for budget-friendly broadband."
  },
  bestBundleProvider: {
    ...BROADBAND_PROVIDER_DEFAULTS.ee,
    awardLabel: <JUDGES_CHOICE />,
    awardTitle: 'Telecoms Bundle Provider of the Year',
    awardDescription:
      "Also winning for Best Telecoms Innovation, EE's new set of premium Wi-Fi features are the freshest example of a modern telecoms bundle in recent times. The provider is dedicated to improving home connectivity in a time where our demand for it is higher than ever."
  },
  bestTVContent: {
    ...BROADBAND_PROVIDER_DEFAULTS.disneyPlus,
    awardLabel: <JUDGES_CHOICE />,
    awardTitle: 'Best TV Content',
    awardDescription:
      "Take an unrivalled library of animated content spanning its own 100-year history, add the Pixar, Marvel and Star Wars universes and a slate of award-winning original shows and it's clear why Disney+ was the runaway winner for Best TV Content."
  },

  networkOfTheYearMobiles: {
    ...MOBILES_PROVIDER_DEFAULTS.tesco,
    awardTitle: 'Network of the Year',
    awardDescription:
      'Our Network of the Year, Tesco Mobile, stands out for its wide-reaching coverage and innovative tariffs. This prestigious award recognises their excellence in meeting the diverse needs of mobile users.'
  },
  handsetOfTheYearMobiles: {
    ...MOBILES_PROVIDER_DEFAULTS.pixel8,
    awardTitle: 'Handset of the Year',
    awardDescription:
      'As voted by our Telecoms Awards judges, the latest flagship Pixel was the top smartphone of 2023. With a stunning new display, insanely true-to-life photography and unparalleled AI features, it edged out all other handsets this year.'
  },

  mostPopularMobileNetwork: {
    ...MOBILES_PROVIDER_DEFAULTS.lebara,
    awardTitle: 'Most Popular Mobile Network',
    awardDescription:
      'Offering a truly good value mobile service, great customer support, flexible 30-day contracts and cheap international calling, Lebara is understandably a huge hit with those surveyed.'
  },
  bestDataMobiles: {
    ...MOBILES_PROVIDER_DEFAULTS.idMobile,
    awardTitle: 'Best Network for Data',
    awardDescription:
      'With very generous mobile data caps for very reasonable prices and free EU roaming, iD Mobile won the category of Best for Data at the Uswitch Telecoms Awards.'
  },
  bestDataRoamingMobiles: {
    ...MOBILES_PROVIDER_DEFAULTS.o2,
    awardTitle: 'Best Network for Roaming',
    awardDescription:
      'The only major network that does not charge extra for EU roaming, O2 was once again a runaway winner for this popular category. Customers appreciated its customer-friendly stance on roaming - a key reason to choose a mobile provider.'
  },
  bestMobilesCustomerService: {
    ...MOBILES_PROVIDER_DEFAULTS.tesco,
    awardTitle: 'Best Network for Customer Service',
    awardDescription:
      "Tesco Mobile wins once again for its peerless customer service. With convenient contact options, attentive staff and compelling price points, Tesco Mobile is a deserving winner for one of Uswitch's most contentious awards."
  },
  bestPerks: {
    ...MOBILES_PROVIDER_DEFAULTS.skyMobile,
    awardTitle: 'Best Network for Perks',
    awardDescription:
      "Sky's perks are amazing for helping customers save their mobile data. Its excellent data rollover benefit, free mobile data streaming of Sky TV content and flexible reward plans means it takes the cake for perks this year."
  },
  fastestNetworkMobiles: {
    ...MOBILES_PROVIDER_DEFAULTS.ee,
    awardTitle: 'Fastest Mobile Network Overall - powered by Opensignal',
    awardAccreditation: `Analysis derived from Opensignal Awards – UK: Mobile Network Experience reports,
April and September 2023, based on independent analysis during the period Dec 1
2022 - Feb 28, 2023 and Jun 1 to Aug 29, 2023.
© 2024 Opensignal Limited.`,
    awardDescription:
      "The reigning champion, Opensignal's data once again pegs EE as the fastest mobile network in the UK.",
    awardSecondaryDescription:
      'Analysis derived from Opensignal Awards - UK: Mobile Network Experience reports, April and September 2023.'
  },

  bestHandsetContractNetwork: {
    ...MOBILES_PROVIDER_DEFAULTS.tesco,
    awardDescription:
      'Tesco Mobile also proved to be a winner for handset contracts in particular. With cheaper prices for Clubcard customers and a compelling selection of devices, Tesco Mobile was, again, a deserving winner for this category.',
    awardTitle: 'Best Handset Contract Network'
  },
  bestPAYGMobiles: {
    ...MOBILES_PROVIDER_DEFAULTS.giffgaff,
    awardTitle: 'Best Pay As You Go Network',
    awardDescription:
      "The provider of choice again for this year with low-cost, no contract monthly plans dubbed 'goodybags', as well as some of the lowest PAYG rates available and the O2 network for coverage, giffgaff was the winner for PAYG network of the year."
  },
  bestSIMOnlyMobiles: {
    ...MOBILES_PROVIDER_DEFAULTS.smarty,
    awardTitle: 'Best SIM Only Network',
    awardDescription:
      "The public's choice for best SIM Only Network, SMARTY's simple, flexible, budget-friendly phoneless contracts and free EU roaming make it the standout network for 2024."
  },
  bestContractValueMobiles: {
    ...MOBILES_PROVIDER_DEFAULTS.idMobile,
    awardTitle: 'Best Contract Value for Money',
    awardDescription:
      "The public's choice for best handset contract value for money, with a range of extremely competitive deals that are hard to beat on price, iD Mobile took the crown for this year."
  },
  bestSIMOValueMobiles: {
    ...MOBILES_PROVIDER_DEFAULTS.smarty,
    awardTitle: 'Best SIM Only Value for Money',
    awardDescription:
      'In keeping with its SIM Only excellence, SMARTY is also recognised for its great SIM value for money. Its quality of service for the price offered was enough to put it No. 1 in the eyes of UK mobile customers.'
  },
  bestESIM: {
    ...MOBILES_PROVIDER_DEFAULTS.airalo,
    awardTitle: 'Best eSIM Provider',
    awardDescription:
      "Airalo leads as our Telecoms Awards' foremost eSIM provider. Offering effortless global connectivity and easy management, it's perfect for the modern, connected world."
  },

  bestTelecomsInovation: {
    providerName: 'EE',
    winnersLogoModal: (
      <img alt="logo" sx={LOGO_STYLES.modal} src={cf2imgix(EE)} />
    ),
    moreWinnersLogoCard: (
      <img alt="logo" sx={LOGO_STYLES.moreWinnersCard} src={cf2imgix(EE)} />
    ),
    awardLabel: <JUDGES_CHOICE />,
    awardTitle: 'Best Telecoms Innovation',
    awardSubtitle: 'for their ‘New EE’ Home Wi-Fi features',
    awardDescription:
      "The new EE' range of Wi-Fi services took the top spot for Best Telecoms Innovation this year. With a new Enhancer function, Pause feature, home guest connectivity and Smart Wi-Fi Plus boosters and backups, EE has now set the standard for the future of home Wi-Fi."
  },
  bestRefurbished: {
    providerName: 'musicMagpie',
    winnersLogoModal: (
      <img
        alt="logo"
        sx={{ height: 'auto', width: 'min(450px, 100%)' }}
        src={cf2imgix(MUSIC_MAGPIE)}
      />
    ),
    moreWinnersLogoCard: (
      <img
        alt="logo"
        sx={LOGO_STYLES.moreWinnersCard}
        src={cf2imgix(MUSIC_MAGPIE)}
      />
    ),
    awardLabel: <JUDGES_CHOICE />,
    awardTitle: 'Best Refurbished Device Supplier',
    awardDescription:
      'The smart and easy way to be sustainable, the judges once again found musicMagpie the leading reseller in the industry, making it simple to buy and sell used technology, and get a good price.'
  }
}
